module.exports = __webpack_public_path__ + "static/media/ConnectedBoxes2.3267a0c3.svg";